<template>
    <div class="modal is-active"
         v-if="isShown"
    >
        <div class="modal-background" @click="cancelHandler"></div>
        <div class="modal-card">

            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ title }}
                </p>
                <button
                    class="delete"
                    aria-label="close"
                    @click="cancelHandler"
                ></button>
            </header>

            <section class="modal-card-body" v-html="text"></section>

            <footer class="modal-card-foot">
                <button
                    class="button is-danger"
                    @click="confirmationHandler"
                >
                    {{ confirmationButtonText }}
                </button>
                <button
                    class="button is-outlined"
                    @click="cancelHandler"
                >
                    {{ cancelButtonText }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "ConfirmationModal",
    props: {
        isShown: false,
        title: String,
        text: String,
        confirmationButtonText: String,
        cancelButtonText: String,
        confirmationHandler: Function,
        cancelHandler: Function,
        colorClass: null,
    },
}
</script>

<style scoped>

</style>